<template>
    <div component="SaveProgressIndicator" load :state="state">
        <div class="progress">Saving</div>
        <div class="done">Saved <span class="icon">done</span></div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'SaveProgressIndicator',

    data() {
        return {};
    },

    props: {
        state: {
            type: String,
            default: '',
        },
    },

    components: {},
};
</script>

<style lang="less">
@import '~@variables';

[component='SaveProgressIndicator'] {
    top: -30px;
    right: 30px;
    font-size: 12px;
    padding: 3px 8px;
    border-radius: 20px;
    background-color: @grey_lt;
    opacity: 0;
    transition: 0.3s;
    transform: scale(0);

    &[load] {
        position: absolute;

        &:after {
            width: 10px;
            height: 10px;
            left: auto;
            right: 4px;
            top: 4px;
            border-width: 2px;
        }
    }

    .progress {
        padding-right: 14px;
    }

    .done {
        .flex-row;
        opacity: 0;
        position: absolute;
        left: 8px;
        top: 1px;
        transition: 0.3s;

        .icon {
            font-size: 20px;
        }
    }

    &[state='saving'] {
        opacity: 1;
        transform: scale(1);
        &:after {
            transition-delay: 0.3s;
        }
    }

    &[state='saved'] {
        opacity: 1;
        transform: scale(1);

        background-color: #69e01869;

        &:after {
            opacity: 0;
        }

        .progress {
            opacity: 0;
        }

        .done {
            opacity: 1;
        }
    }
}
</style>
